export const ObjectNames = {
  TabbedPage: "tabbedPage",
  ObjectList: "objectList",
  ObjectEdit: "objectEdit",
  ObjectDelete: "objectDelete",
  AttachmentsList: "attachmentsList",
  ObjectListFilters: "objectListFilters",
  MenuItemGridCustomAction: "menuItemGridCustomAction",
  Tabs: "tabs",
  Separator: "_",
};

export const createTabbedPageUniqueName = (uuid) => {
  return ObjectNames.TabbedPage + ObjectNames.Separator + uuid;
};

export const createObjectUniqueName = (objectName, objectId) => {
  return objectName + ObjectNames.Separator + objectId;
};
